import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useParticipantAccess } from "./participantAccess";

/**
 * Legacy deep links (/feasibility/new, /feasibility/:id/edit) open the same
 * full-width Create/Edit modal on the Feasibility list — matching existing CTMS.
 */
const FeasibilityEditor = () => {
  const { participantId } = useParams();
  const isEdit = Boolean(participantId);
  const { canViewFeasibility, loading: accessLoading } = useParticipantAccess();

  if (accessLoading) {
    return <div className="participant-manager-page pm-page--bootstrapping" />;
  }
  if (!canViewFeasibility) {
    return <Navigate to="/notification-center" replace />;
  }

  return (
    <Navigate
      to="/participantmanager/feasibility"
      replace
      state={
        isEdit
          ? { openEditFeasibilityId: participantId }
          : { openCreateFeasibility: true }
      }
    />
  );
};

export default FeasibilityEditor;
